import {
  initialState,
  Actions,
  State,
  NEW_MODULE,
  NEW_MODULE_SUCCESS,
  NEW_MODULE_ERROR,
  RESET_NEW_MODULE,
} from "../../types/module/new-module";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_MODULE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_MODULE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_MODULE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_MODULE:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
